<template>
  <div>
    <div class="hearder" v-bind:class="{ 'navActive1': scrollFlag }">
      <header class="pc-header">
        <div class="logo-box">
          <img
            src="../assets/img/f2.png"
            style="height: 50px;width: 123px;"
            v-show="!scrollFlag"
          />
          <img src="../assets/img/fang.png" style="height: 50px;width: 123px;" v-show="scrollFlag" />
        </div>
        <div class="logo-box">
          <img
            src="../assets/img/nav_logo.png"
            style="height: 45px;width: 153px;"
            v-show="!scrollFlag"
          />
          <img src="../assets/img/logo.png" style="height: 45px;width: 153px;" v-show="scrollFlag" />
        </div>
        <div class="logo-positioning">
          <img src="../assets/img/positioning.png" v-show="!scrollFlag" />
          <img src="../assets/img/dw.png" v-show="scrollFlag" />
          <span class="logo-positioning-title" v-bind:class="{ 'navActive': scrollFlag }">城市分站</span>
          <div class="positioning-nav">
            <span @click="toOther('http://sx.yunzhengshou.com/')">绍兴</span>
            <span @click="toOther('http://qz.yunzhengshou.com/')">衢州</span>
            <span @click="toOther('http://sz.yunzhengshou.com/')">深圳</span>
            <span @click="toOther('http://yuexi.yunzhengshou.com/')">安庆</span>
            <span @click="toOther('http://mianzhu.yunzhengshou.com/')">德阳</span>
          </div>
        </div>
        <div class="nav-box">
          <div
            class="nav-item"
            v-for="(item, index) in navList"
            :key="index"
            v-bind:class="{ 'navActive': scrollFlag }"
            @click="test(item.path,index)"
          >
            <div v-show="!scrollFlag" @mouseenter="addHandler(index)">
              <p class="item-cn">{{ item.title }}</p>
              <p class="item-en">{{ item.en }}</p>
            </div>
            <!-- <p
              :class=" navIndex === index ? 'item-cn item-cn-active' : 'item-cn'"
              v-show="!scrollFlag"
            >{{ item.title }}</p>
            <p
              :class="navIndex === index ? 'item-en item-en-active' : 'item-en'"
              v-show="!scrollFlag"
            >{{ item.en }}</p>-->
            <div v-show="scrollFlag" @mouseenter="addHandler(index)">
              <p
                class="item-cn-text"
                :class="navIndex === index ? 'item-cn-newActive' : ''"
              >{{ item.title }}</p>
              <p
                class="item-en-text"
                :class="navIndex === index ? 'item-en-newActive' : ''"
              >{{ item.en }}</p>
            </div>
            <!-- <ul v-if="index == 0" class="dropdownWrapper" v-show="dropdownActive">
              <li v-for="(item, index) in dropParams" :key="index">{{item}}</li>
            </ul>-->
          </div>
          <vertical-toggle>
            <div
              v-show="flag"
              class="product-nav"
              @mouseleave="testIndex == 1 && addGoodsHandler()"
            >
              <div
                class="product-nav-one"
                v-for="(item,index) in productNav"
                :key="index"
                @click="toTest(item.path)"
              >{{item.title}}</div>
              <!-- <div class="product-nav-one" @click="toTest('/whole')">全程端</div>
              <div class="product-nav-one" @click="toTest('/collection')">征收综合平台</div>
              <div class="product-nav-one" @click="toTest('/client')">被征收户端端</div>-->
            </div>
          </vertical-toggle>
          <vertical-toggle>
            <div v-show="showFlag" class="service-nav" @mouseleave="testIndex == 2 && addService()">
              <div class="product-nav-one" @click="toTest1('/service')">无人机航拍</div>
              <div class="product-nav-one" @click="toTest1('/process')">全流程征收</div>
              <div class="product-nav-one" @click="toTest1('/management')">档案管理</div>
              <div class="product-nav-one" @click="toTest1('/panoramic')">全景航拍</div>
            </div>
          </vertical-toggle>
        </div>
        <div class="btn">
          <div
            class="btn-login"
            v-bind:class="{ 'textActive': scrollFlag }"
            @mouseenter="addLogin()"
            @mouseleave="loginRemove()"
          >登录</div>
          <vertical-toggle>
            <div
              class="login-nav"
              v-show="showLogin"
              @mouseleave="loginRemove()"
              @mouseenter="addLogin()"
            >
              <div class="login-nav-one" @click="toLogin('https://ev.yunzhengshou.com/login')">评估端</div>
              <div class="login-nav-one" @click="toLogin('https://ep.yunzhengshou.com')">全程端</div>
              <div class="login-nav-one" @click="toLogin('https://zs.yunzhengshou.com')">智慧征收系统</div>
            </div>
          </vertical-toggle>
          <div
            v-if="showBtn"
            class="btn-use"
            v-bind:class="{ 'textActive': scrollFlag }"
            @click="toApplication()"
          >申请试用</div>
          <!-- <div class="btn-use" v-else></div> -->
        </div>
      </header>
    </div>
  </div>
</template>
<script>
import VerticalToggle from '@/components/vertical-toggle/vertical-toggle.js';
export default {
  name: 'Heater',
  components: {
    VerticalToggle
  },
  data() {
    return {
      navList: [
        { title: '首页', en: 'Home', path: '/public' },
        { title: '产品', en: 'Product', path: '/product' },
        { title: '服务', en: 'Service', path: '/service' },
        { title: '案例', en: 'Case', path: '/case' },
        { title: '资讯', en: 'News', path: '/news' },
        { title: '关于', en: 'About', path: '/about' }
      ],
      productNav: [
        {
          title: '评估端',
          path: '/product'
        },
        {
          title: '全程端',
          path: '/whole'
        },
        {
          title: '智慧征收系统',
          path: '/collection'
        },
        {
          title: '被征收户端',
          path: '/client'
        }
      ],
      navIndex: 0,
      testIndex: 0,
      scrollFlag: false,
      flag: false,
      showFlag: false,
      showLogin: false,
      showBtn: true
    };
  },
  methods: {
    test(path, index) {
      // if (index = 1) {
      //   this.flag = !this.flag;
      // } else {
      //   this.flag = false;
      // }
      // if (index == 2) {
      //   this.showFlag = !this.showFlag;
      // } else {
      //   this.showFlag = false;
      // }
      if (index != 1 && index != 2) {
        this.$router.push({ path: path });
      }
    },
    toTest(item) {
      this.$router.push(item);
      this.flag = false;
    },
    toTest1(item) {
      this.$router.push(item);
      this.showFlag = false;
    },
    routerLink(index, path) {
      this.navIndex = index;
      this.$router.push(path);
    },
    checkRouterLocal(path) {
      if (path === '/whole' || path === '/collection' || path === '/client') {
        this.navIndex = 1;
      } else if (path === '/gis' || path === '/gisOther') {
        this.navIndex = '';
      } else if (
        path === '/process' ||
        path === '/management' ||
        path === '/panoramic'
      ) {
        this.navIndex = 2;
      } else {
        // console.log(path.length);
        if (path.length >= 16) {
          path = path.split('/')[1];
        }
        let that = this;
        // this.navIndex = this.navList.findIndex(item => item.path === path);
        this.navList.forEach(function(item, index) {
          if (item.path.indexOf(path) != -1) {
            that.navIndex = index;
            // console.log(that.navIndex);
          }
        });
      }
    },
    handleScroll() {
      let _this = this;
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop) {
        _this.scrollFlag = true;
      } else {
        _this.scrollFlag = false;
      }
    },
    toApplication() {
      this.flag = false;
      this.showFlag = false;
      this.$router.push('/application');
    },
    toOther(path) {
      window.open(path);
    },
    toLogin(path) {
      window.open(path);
    },
    addGoodsHandler() {
      this.flag = false;
    },
    addHandler(index) {
      this.testIndex = index;
      if (index === 1) {
        this.flag = !this.flag;
      } else {
        this.flag = false;
      }
      if (index === 2) {
        this.showFlag = !this.showFlag;
      } else {
        this.showFlag = false;
      }
    },
    addService() {
      this.showFlag = false;
    },
    addLogin() {
      this.showLogin = true;
    },
    loginRemove() {
      this.showLogin = false;
    }
  },
  watch: {
    $route(to, from) {
      let path = this.$route.path;
      if (this.$route.path != '/public') {
        this.scrollFlag = true;
        window.removeEventListener('scroll', this.handleScroll);
      } else {
        this.scrollFlag = false;
        window.addEventListener('scroll', this.handleScroll);
      }
      if (this.$route.path === '/application') {
        this.scrollFlag = false;
        this.showBtn = false;
      } else {
        this.showBtn = true;
      }
      this.checkRouterLocal(path);
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    let path = this.$route.path;
    this.checkRouterLocal(path);
    if (path != '/public') {
      this.scrollFlag = true;
      window.removeEventListener('scroll', this.handleScroll);
    }
    // console.log(this.$route.path);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
};
</script>
<style scoped>
.hearder {
  background: rgb(0, 189, 183);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
}
.navActive {
  background: #ffffff;
  color: #1e1e1e !important;
}
.navActive1 {
  background: #ffffff;
  color: #1e1e1e !important;
  box-shadow: 2px 5px 5px rgba(102, 102, 102, 0.349019607843137);
}
.item-cn-text {
  background: #ffffff;
  color: #1e1e1e;
  font-weight: 700;
  font-size: 18px;
}
.item-en-newActive,
.item-cn-newActive {
  color: rgb(0, 189, 183) !important;
}
.item-en-text {
  background: #ffffff;
  color: #1e1e1e;
  font-weight: 400;
  font-size: 14px;
}
.router-link-active {
  color: #8fc526 !important;
  /* border-top: 4px solid #8fc526!important; */
}
.textActive {
  color: rgb(0, 189, 183) !important;
  border-color: rgba(0, 189, 183, 1) !important;
}
.pc-header {
  margin: 0 auto;
  width: 1500px;
  height: 80px;
  line-height: 80px;
}
.logo-box {
  width: 142px;
  height: 50px;
  float: left;
  margin-top: 18px;
}
.pc-title {
  float: left;
  font-weight: 700;
  font-style: normal;
  font-size: 25px;
  margin-left: 275px;
  margin-top: 10px;
}
.btn {
  position: relative;
  float: right;
  display: flex;
}
.btn-login {
  width: 80px;
  height: 40px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 10px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #ffffff;
  margin-top: 30px;
  margin-right: 10px;
}
.btn-use {
  width: 110px;
  height: 40px;
  cursor: pointer;
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 10px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #ffffff;
  margin-top: 30px;
}
.logo-positioning {
  position: relative;
  float: left;
  cursor: pointer;
}
.logo-positioning:hover .positioning-nav {
  display: block;
}
.positioning-nav {
  position: absolute;
  cursor: pointer;
  top: 61px;
  left: 31px;
  width: 208px;
  height: 25px;
  background: #ffffff;
  line-height: 25px;
  border: 1px solid #e8e8e8;
  font-size: 14px;
  display: none;
  z-index: 1000;
}
.positioning-nav span {
  padding: 0 5px;
}
.logo-positioning img {
  width: 18px;
  height: 18px;
  margin-left: 28px;
}
.logo-positioning-title {
  font-size: 14px;
  color: #ffffff;
}
.nav-box {
  float: left;
  display: flex;
  margin-left: 140px;
  margin-top: 16px;
  position: relative;
}

.nav-item {
  text-align: center;
  padding: 0 32px;
  position: relative;
  display: inline-block;
  font-size: 18px;
  line-height: 7px;
  cursor: pointer;
}
.product-nav {
  position: absolute;
  left: 91px;
  top: 59px;
  width: 130px;
  height: 200px;
  font-size: 16px;
  color: #333333;
  text-align: center;
  background: rgba(245, 245, 245, 0.9);
  border: 1px solid #f5f5f5;
}
.service-nav {
  position: absolute;
  left: 203px;
  top: 59px;
  width: 130px;
  height: 200px;
  font-size: 16px;
  color: #333333;
  text-align: center;
  background: rgba(245, 245, 245, 0.9);
  border: 1px solid #f5f5f5;
}
.login-nav {
  position: absolute;
  left: -21px;
  top: 74px;
  width: 130px;
  height: 150px;
  font-size: 16px;
  color: #333333;
  text-align: center;
  background: rgba(245, 245, 245, 0.9);
  border: 1px solid #f5f5f5;
}
.product-nav-one,
.login-nav-one {
  height: 50px;
  line-height: 50px;
  color: #333333;
  cursor: pointer;
}
.product-nav-one:hover {
  color: rgb(0, 189, 183);
}
.login-nav-one:hover {
  color: rgb(0, 189, 183);
}
/*导航普通状态*/
.item-cn {
  color: #ffffff;
  font-weight: 700;
}

/*导航普通状态*/
.item-en {
  color: #ffffff;
  font-weight: 400;
  font-size: 14px;
}

/*导航高亮*/
.item-cn-active {
  color: #2d8cf0;
}

/*导航高亮*/
/* .item-en-active {
  color: #5cadff;
} */

/* .nav-item:hover .item-cn {
  color: #2d8cf0;
}

.nav-item:hover .item-en {
  color: #5cadff;
} */
.nav-item:after:last-child {
  width: 0;
}
.btn-login:hover {
  background: rgb(0, 189, 183);
  color: #ffffff !important;
}
.btn-use:hover {
  background: rgb(0, 189, 183);
  color: #ffffff !important;
}
.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: rgb(0, 189, 183) !important;
  color: #ffffff !important;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .pc-header {
    width: 1200px !important;
  }
  .nav-box {
    margin-left: 48px !important;
  }
  /* .positioning-nav {
    top: 75px!important;
  } */
}
@media screen and (max-device-width: 1200px) {
  .pc-header {
    width: 100% !important;
  }
  /* .positioning-nav {
    top: 75px!important;
  } */
}
</style>



// WEBPACK FOOTER //
// src/layout/nav.vue